import { bool, node, oneOfType, string } from 'prop-types'

import BorderedText from 'views/components/atoms/BorderedText'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'

const SearchProductLabel = ({
  label,
  firstFound,
  showInfoIcon = false,
  ...rest
}) => (
  <BorderedText
    {...rest}
    smaller
    skewed={firstFound}
    skewedRight={!firstFound}
    notexttransform
  >
    {label}
    {showInfoIcon && <IconCircleInfoOutline size="x-small" />}
  </BorderedText>
)

SearchProductLabel.propTypes = {
  ...BorderedText.propTypes,
  label: oneOfType([node, string]).isRequired,
  children: node,
  firstFound: bool,
  showInfoIcon: bool,
}

SearchProductLabel.defaultProps = {
  ...BorderedText.defaultProps,
  firstFound: false,
  label: null,
  children: null,
  showInfoIcon: false,
}

export default SearchProductLabel
